module.exports = __webpack_public_path__ + "img/gsb47.b50703ae.png";